import './CopyFacility.css'

export const CopyFacility = () => {
	return (
		<>
		<div>TODO CopyFacility</div>

		</>
	)
 }